import React from 'react';
import { Form } from 'react-bootstrap';
import StylishNewSelect from '../../../DesignSystems/New/StylishNewSelect';

interface ResourceRequestKanbanFiltersProps {
  selectedResourceKind: string;
  onResourceKindChange: (value: string) => void;
  availableResourceKinds: string[];
  showCancelled: boolean;
  onShowCancelledChange: (value: boolean) => void;
}

const ResourceRequestKanbanFilters: React.FC<
  ResourceRequestKanbanFiltersProps
> = ({
  selectedResourceKind,
  onResourceKindChange,
  availableResourceKinds,
  showCancelled,
  onShowCancelledChange,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="d-flex align-items-center">
        <label className="me-2">Filter by Resource:</label>
        <StylishNewSelect
          value={
            selectedResourceKind === 'all'
              ? { value: 'all', label: 'All Resources (Required or Requested)' }
              : { value: selectedResourceKind, label: selectedResourceKind }
          }
          onChange={(option) => onResourceKindChange(option?.value || 'all')}
          options={[
            { value: 'all', label: 'All Resources (Required or Requested)' },
            ...availableResourceKinds.map((kind) => ({
              value: kind,
              label: kind,
            })),
          ]}
          placeholder="Select resource type..."
          isClearable={false}
          isSearchable={true}
          style={{ minWidth: '250px' }}
        />
      </div>
      <Form.Check
        type="switch"
        id="show-cancelled-toggle"
        label="Show Cancelled Requests"
        checked={showCancelled}
        onChange={(e) => onShowCancelledChange(e.target.checked)}
      />
    </div>
  );
};

export default ResourceRequestKanbanFilters;
